import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractCheckboxInput} from "../abstract-checkbox-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineCheckboxInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-checkbox-input",
    styleUrls: ["./inline-checkbox-input.component.scss"],
    templateUrl: "./inline-checkbox-input.component.html",
    standalone: false
})
export class FUIInlineCheckboxInputComponent extends FUIAbstractCheckboxInput {

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    // An inline checkbox has a default fascia when enabled to allow it to fill the grid cell - clicks in the fascia are for focus only.
    // The template handles clicks on the checkbox directly and calls click().
    public override mouseClick(event?: MouseEvent): void {
        this.focus();
    }
}
